import {
  selectRosterDisplayName,
  selectTournamentDriverName,
} from "selectors/Roster";
import {
  DisplayName,
  TeamRecord,
  DriverNames,
  OrgLogoContainer,
} from "./styles";
import { selectRosterSegmentRecordFromMatchId } from "selectors/Tournament";
import { CenterFlexColumn } from "styles/layout";
import { RosterOrgLogo } from "components/Logo/RosterOrgLogo";
import { useAppSelector } from "app/hooks";

interface Props {
  matchId: string;
  rosterId: string;
  driverIds: string[];
  tournamentId: string;
}

export const MatchViewerH2HTeam = ({
  matchId,
  rosterId,
  driverIds,
  tournamentId,
}: Props) => {
  const displayName = useAppSelector((state) =>
    selectRosterDisplayName(state, rosterId, tournamentId)
  );
  const driverNicknames = useAppSelector((state) =>
    driverIds.map(
      (id) => selectTournamentDriverName(state, id, tournamentId) ?? "-"
    )
  );

  const record = useAppSelector((state) =>
    selectRosterSegmentRecordFromMatchId(state, matchId, rosterId)
  );

  return (
    <CenterFlexColumn>
      <OrgLogoContainer>
        {!!rosterId && (
          <RosterOrgLogo rosterId={rosterId} tournamentId={tournamentId} />
        )}
      </OrgLogoContainer>
      <DisplayName>{displayName ?? "-"}</DisplayName>

      {!!record && (
        <TeamRecord>
          ({record.wins} - {record.loses})
        </TeamRecord>
      )}
      <DriverNames>{driverNicknames.join(" | ")}</DriverNames>
    </CenterFlexColumn>
  );
};
